import type { CustomerQuote } from '@talos/kyoko';
import { compact } from 'lodash-es';
import { useReducer } from 'react';
import { useFixingIndices } from '../../../providers/FixingIndexProvider';
import { type FixingState, fixingSliceReducer, getInitialFixingState } from './fixingSlice';
import { getAllFixingIndicesFromCustomerQuotes } from './utils';

/** Given the selectedCustomerQuotes (on init), will build the initial state, create a reducer, and return the state and dispatch fn */
export const useFixingState = (selectedCustomerQuotes: CustomerQuote[]) => {
  const { fixingIndicesByName } = useFixingIndices();

  const [state, dispatch] = useReducer(fixingSliceReducer, undefined, (): FixingState => {
    // Grab all unique fixing indices we find on the provider CQs and init the state with those
    return getInitialFixingState({
      fixingIndices: compact(
        [...getAllFixingIndicesFromCustomerQuotes(selectedCustomerQuotes)].map(fi => fixingIndicesByName.get(fi))
      ),
    });
  });

  return { state, dispatch };
};
